import dateFormat from 'dateformat';

const formatClosedJobs = (jobs) => {
  return jobs.map((job) => {
    const postingDate = new Date(job.postingDate);
    const closedFilledDate = new Date(job.closedFilledDate);
    return {
      ...job,
      formattedPostingDate: dateFormat(postingDate, 'mm-dd-yyyy'),
      formattedClosedFilledDate: dateFormat(closedFilledDate, 'mm-dd-yyyy'),
    };
  });
};

export default formatClosedJobs;
